import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { InvestmentStatusTag } from "components/ui/atoms/Tag";

const DealListItemShort = ({ object: deal, primaryClick }) => {
  return (
    <ListItemButton onClick={() => primaryClick(deal)}>
      <ListItemAvatar variant="small">
        <Avatar
          src={`http://logo.clearbit.com/${deal.company_detail.best_domain}`}
        >
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={deal.company_detail.best_name}
        secondary={deal.deal_flow_detail.name}
      />
      <ListItemText
        primary={<InvestmentStatusTag status={deal.investment_status} />}
        sx={{ flexShrink: 0, flexGrow: 0, ml: 1 }}
      />
    </ListItemButton>
  );
};

export default DealListItemShort;
